export const TESLIM_EDILDI = 'TESLIM_EDILDI';
export const DEGISIKLIKLERI_KAYDET = 'DEGISIKLIKLERI_KAYDET';
export const SIPARIS_IPTAL = 'SIPARIS_IPTAL'

export const TESLIM_EDILEMEDI = "TESLIM_EDILEMEDI"